import React, { useEffect, useState } from 'react'
import '../spare/cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { productTypes } from '../../../assets/javascript/const-data'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'


const CUParentProduct = ({ currentData, setModal, setData, isEdit }) => {
    const [form, setForm] = useState({})
    const [spareForm, setSpareForm] = useState({})
    const [attributeForm, setAttributeForm] = useState({})
    const [loading, setLoading] = useState('')


    const handleChange = (e) => {

        let updatedForm = {
            ...form,
            [e.target.name]: e.target.value
        };
        setForm(updatedForm);
    }

    const handleChangeItemForm = (e) => {
        setSpareForm({
            ...(spareForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleChangeAttributeForm = (e) => {
        setAttributeForm({
            ...(attributeForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleAddSpare = () => {
        if (!spareForm?.spare_id || !spareForm?.qty) {
            return;
        }

        const existed = form?.spares?.find(i => i?.spare_id === spareForm?.spare_id)
        if (existed) {
            toast.error('The Spare Id already exited')
            return
        }

        setForm({
            ...form,
            spares: [
                ...(form?.spares || []),
                spareForm
            ]
        })

        setSpareForm({})
    }

    const handleAddAttribute = () => {
        if (!attributeForm?.label || !attributeForm?.variant) {
            return;
        }

        const existed = form?.attributes?.find(i => i?.label === attributeForm?.label)
        if (existed) {
            toast.error('The Attribute already exited')
            return
        }

        setForm({
            ...form,
            attributes: [
                ...(form?.attributes || []),
                {
                    ...attributeForm,
                    variant: attributeForm?.variant === 'Yes' ? true : false
                }
            ]
        })

        setAttributeForm({})
    }

    const removeItem = (spare_id) => {
        setForm({
            ...form,
            spares: (form?.spares || [])?.filter(i => i?.spare_id !== spare_id)
        })
    }

    const removeAttribute = (label) => {
        setForm({
            ...form,
            attributes: (form?.attributes || [])?.filter(i => i?.label !== label)
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading('submit')
        const body = {
            product_name: form?.product_name,
            product_category: form?.product_category,
            brand: form?.brand,
            attributes: form?.attributes,
            spares: form?.spares,
            is_service_product: form?.is_service_product === 'Yes' ? true : false,
            is_rental_product: form?.is_rental_product === 'Yes' ? true : false,
            warranty_period: Number(form?.warranty_period) || 0,
            tax_percentage: Number(form?.tax_percentage) || 0,
        }

        if (isEdit) {
            customerAxios.put(`/production-v0/parent-product/${currentData?.product_code}`, body).then(() => {
                setModal({ status: false })
                toast.success(`Product Updated! \n Refresh and Reopen the Product to View`)
                setLoading('')


            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
        } else {
            // Create new 
            customerAxios.post(`/production-v0/parent-product`, body).then(() => {
                setModal({ status: false })
                toast.success(`Product Created! \n Refresh and Reopen the Product to View`)
                setLoading('')

            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
        }
    }

    useEffect(() => {
        if (isEdit) {
            const temp = {
                product_name: currentData?.product_name,
                product_category: currentData?.product_category,
                brand: currentData?.brand,
                is_service_product: currentData?.is_service_product ? "Yes" : 'No',
                is_rental_product: currentData?.is_rental_product ? "Yes" : 'No',
                attributes: currentData?.attributes?.map(i => ({ label: i?.label, variant: i?.variant })),
                warranty_period: currentData?.warranty_period,
                tax_percentage: currentData?.tax?.tax_percentage,
                spares: currentData?.spares?.map(i => ({ spare_id: i?.spare_id, qty: i?.qty }))
            }

            setForm(temp)
        }
        // eslint-disable-next-line
    }, [currentData])

    return (
        <div className="cu-spare-sub-div">
            {loading === 'submit'
                ? <p>Loading....</p>
                : <form action="" onSubmit={handleSubmit}>
                    <div className="input-group-div">
                        <NormalInput label='Product Name *' name='product_name' value={form?.product_name} onChangeFun={handleChange} />
                        <SelectInput label='Product Category *' name='product_category' values={productTypes?.map((u) => ({ option: u, value: u, selected: u === form?.product_category }))} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} />
                        <NormalInput label='Brand *' name='brand' value={form?.brand} onChangeFun={handleChange} />
                        <SelectInput label='Service Product *' name='is_service_product' values={['Yes', 'No']?.map((u) => ({ option: u, value: u, selected: u === form?.is_service_product }))} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} />
                        <SelectInput label='Rental Product *' name='is_rental_product' values={['Yes', 'No']?.map((u) => ({ option: u, value: u, selected: u === form?.is_rental_product }))} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} />
                        <NormalInput label='Warranty Duration (Months)*' type={'number'} min={0} name='warranty_period' value={form?.warranty_period} onChangeFun={handleChange} />
                        <NormalInput label='Tax Percentage (%)*' type={'number'} min={0} max={100} name='tax_percentage' value={form?.tax_percentage} onChangeFun={handleChange} />
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Attribute Labels</h4>
                    <div className="item-list-div">
                        <table>
                            <tbody>
                                {form?.attributes?.map((item) => {
                                    return <tr key={item?.label}>
                                        <td>{item?.label}</td>
                                        <td>{item?.variant ? 'Variant' : ''}</td>
                                        <td>
                                            <button type='button' onClick={() => removeAttribute(item?.label)}>
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="add-item-div" style={{ gridTemplateColumns: '1fr 1fr 100px' }}>
                        <NormalInput label='Label ' name='label' value={attributeForm?.label} onChangeFun={handleChangeAttributeForm} isRequired={false} />
                        <SelectInput label='Usage as Variant ' name='variant' values={['Yes', 'No']?.map((u) => ({ option: u, value: u, selected: u === attributeForm?.variant }))} onChangeFun={handleChangeAttributeForm}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                        <button type='button' onClick={handleAddAttribute}>Add</button>
                    </div>

                    <h4 style={{ fontSize: "14px", marginTop: "10px" }}>Spares</h4>
                    <div className="item-list-div">
                        <table>
                            <tbody>
                                {form?.spares?.map((item) => {
                                    return <tr>
                                        <td>{item?.spare_id}</td>
                                        <td>Qty : {item?.qty}</td>
                                        <td>
                                            <button type='button' onClick={() => removeItem(item?.spare_id)}>
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="add-item-div">
                        <NormalInput label='Spare Id' name='spare_id' value={spareForm?.spare_id} onChangeFun={handleChangeItemForm} isRequired={false} />
                        <NormalInput label='Qty' name='qty' value={spareForm?.qty} onChangeFun={handleChangeItemForm} isRequired={false} type={'number'} min={1} />
                        <button type='button' onClick={handleAddSpare}>Add</button>
                    </div>

                    <button>Submit</button>
                </form>}
        </div>
    )
}

export default CUParentProduct